import { memo } from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';

import { bgBlur } from 'src/theme/css';
import { useGetGeneralStatisticsQuery, useGetManagePermissionsQuery } from 'src/redux/coreApi';

import { NavSectionHorizontal } from 'src/components/nav-section';

import { HEADER } from '../config-layout';
import { useNavData } from './config-navigation';
import HeaderShadow from '../_common/header-shadow';

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();

  const { data = {} } = useGetGeneralStatisticsQuery();

  const usersToValidate = data.requestsToValidate ?? 0;

  const runningCampaigns = data.runningCampaigns ?? 0;

  const newMessages = data.newMessages ?? 0;

  const { data: permissions } = useGetManagePermissionsQuery();

  const navData = useNavData(usersToValidate, runningCampaigns, newMessages, permissions);

  return (
    <AppBar
      component="nav"
      sx={{
        top: HEADER.H_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal
          data={navData}
          config={{
            currentRole: 'admin',
          }}
        />
      </Toolbar>

      <HeaderShadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);
